import React from 'react';
import * as R from 'ramda';

import {toTitleCase} from 'js/common/string_helper';
import {exists} from 'js/common/object_helper';
import {DistributionChannel} from '../../common/language';

const {CampaignAudienceAge, CampaignAudienceAgeMap} = window.sn.enums;

const TargetDetails = ({
    audienceLocation,
    audienceLocationCustom,
    audienceGender,
    followerCount,
    audienceLanguages,
    audienceAge,
    audienceInterests,
    age21Plus,
    influencerFamilyFriendly,
    creatorFraudDetectionEnabled,
    gqlData,
    isLegacyCampaign
}) => {
    let locationVal;
    if (isLegacyCampaign) {
        locationVal = !R.isNil(audienceLocation) ? audienceLocation.toUpperCase() : 'N/A';
        if (exists(audienceLocationCustom)) {
            locationVal = `${locationVal}: ${audienceLocationCustom}`;
        }
    } else {
        locationVal = Array.isArray(audienceLocation)
            ? toTitleCase(audienceLocation.join(', '))
            : 'N/A';
    }

    const genderVal = audienceGender ? toTitleCase(audienceGender) : 'N/A';
    const languagesVal = audienceLanguages ? R.join(', ', R.split(',', audienceLanguages)) : 'N/A';
    const ages = Array.isArray(audienceAge) ? audienceAge : R.split(',', audienceAge);

    let ageRangeVal;
    if (isLegacyCampaign) {
        ageRangeVal =
            audienceAge.length > 0
                ? R.join(
                      ', ',
                      R.map(
                          ageRange =>
                              CampaignAudienceAge[ageRange] || CampaignAudienceAgeMap[ageRange],
                          ages
                      )
                  )
                : 'N/A';
    } else {
        ageRangeVal = ages.length > 0 ? ages.join(', ') : 'N/A';
    }

    const audienceInterestsVal = audienceInterests
        ? R.join(
              ', ',
              R.map(interest => toTitleCase(interest), R.split(',', audienceInterests))
          )
        : 'N/A';
    const age21PlusVal = age21Plus ? 'Yes' : 'No';
    const influencerFamilyFriendlyVal = influencerFamilyFriendly ? 'Yes' : 'No';
    const creatorFraudDetectionEnabledVal = creatorFraudDetectionEnabled ? 'Yes' : 'No';

    const renderCustomLocations = () => {
        if (!isLegacyCampaign && gqlData && gqlData.customLocations) {
            return (
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Custom Locations</div>
                    <div className="section-details-value">{gqlData.customLocations}</div>
                </div>
            );
        }

        return null;
    };

    const renderConquestingCreators = () => {
        if (
            !isLegacyCampaign &&
            gqlData &&
            gqlData.conquestingBrands &&
            gqlData.conquestingBrands.include.items.length > 0
        ) {
            return (
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Conquesting Creator Brands</div>
                    <div className="section-details-value">
                        {gqlData.conquestingBrands.include.items.map(item => item.value).join(', ')}
                    </div>
                </div>
            );
        }

        return null;
    };

    const renderExcludeCreators = () => {
        if (
            !isLegacyCampaign &&
            gqlData &&
            gqlData.conquestingBrands &&
            gqlData.conquestingBrands.exclude.items.length > 0
        ) {
            return (
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Exclude Creator Brands</div>
                    <div className="section-details-value">
                        {gqlData.conquestingBrands.exclude.items.map(item => item.value).join(', ')}
                    </div>
                </div>
            );
        }

        return null;
    };

    const renderFollowerCount = () => {
        // Legacy campaign dont have follower count
        if (!isLegacyCampaign && gqlData.contentUse === DistributionChannel.SOCIAL) {
            return (
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Follower Count</div>
                    <div className="section-details-value">{followerCount}</div>
                </div>
            );
        }
    };

    return (
        <div className="target-details">
            <div className="section-title">Target</div>
            <div className="target-details-grid">
                <div className="target-detail">
                    <div className="section-details-title">Gender</div>
                    <div className="section-details-value">{genderVal}</div>
                </div>
                {renderFollowerCount()}
                <div className="target-detail">
                    <div className="section-details-title">Languages</div>
                    <div className="section-details-value">{languagesVal}</div>
                </div>
                <div className="target-detail">
                    <div className="section-details-title">Location</div>
                    <div className="section-details-value">{locationVal}</div>
                </div>
                {renderCustomLocations()}
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Age Range</div>
                    <div className="section-details-value">{ageRangeVal}</div>
                </div>
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Interests</div>
                    <div className="section-details-value">{audienceInterestsVal}</div>
                </div>
                <div className="target-detail">
                    <div className="section-details-title">21+ only</div>
                    <div className="section-details-value">{age21PlusVal}</div>
                </div>
                <div className="target-detail">
                    <div className="section-details-title">Family Friendly</div>
                    <div className="section-details-value">{influencerFamilyFriendlyVal}</div>
                </div>
                <div className="target-detail target-detail-full">
                    <div className="section-details-title">Premium Audience Score</div>
                    <div className="section-details-value">{creatorFraudDetectionEnabledVal}</div>
                </div>
                {renderConquestingCreators()}
                {renderExcludeCreators()}
            </div>
        </div>
    );
};

export default TargetDetails;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/target_details.js